import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Alert, Table, Badge } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const Settings = () => {
  const { user } = useAuth();
  const [message, setMessage] = useState({ type: '', text: '' });
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    loadTeamMembers();
  }, []);

  const loadTeamMembers = async () => {
    try {
      const response = await axios.get('/api/users/team');
      setTeamMembers(response.data);
    } catch (error) {
      console.error('Failed to load team members:', error);
    }
  };

  const getRoleBadge = (role) => {
    const variant = role === 'admin' ? 'danger' : 'primary';
    return <Badge bg={variant}>{role}</Badge>;
  };

  return (
    <Container>
      <Row className="mt-3">
        <Col>
          <h2 className="mb-4">
            <i className="fas fa-cog me-2"></i>
            Settings
          </h2>

          {message.text && (
            <Alert variant={message.type} className="mb-3">
              {message.text}
            </Alert>
          )}

          {/* Team Management */}
          <Card className="mb-4">
            <Card.Header className="bg-primary text-white">
              <h5 className="mb-0">
                <i className="fas fa-users me-2"></i>
                Team Management
              </h5>
            </Card.Header>
            <Card.Body>
              <p className="text-muted mb-3">
                View your current team members. To invite new colleagues, use the "Invite Colleague"
                button on the Dashboard.
              </p>

              {/* Current Team Members */}
              <h6 className="mb-3">Your Team Members</h6>
              {teamMembers.length > 0 ? (
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Joined</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teamMembers.map((member) => (
                      <tr key={member.id}>
                        <td className="fw-medium">
                          {member.first_name} {member.last_name}
                        </td>
                        <td>{member.email}</td>
                        <td>{getRoleBadge(member.role)}</td>
                        <td>
                          <Badge bg="success">Active</Badge>
                        </td>
                        <td className="text-muted">
                          {new Date(member.created_at).toLocaleDateString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center py-4">
                  <i className="fas fa-users fs-1 text-muted mb-3"></i>
                  <p className="text-muted">No team members found</p>
                </div>
              )}
            </Card.Body>
          </Card>

          {/* Account Information */}
          <Card className="mb-4">
            <Card.Header className="bg-info text-white">
              <h5 className="mb-0">
                <i className="fas fa-user me-2"></i>
                Account Information
              </h5>
            </Card.Header>
            <Card.Body>
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Name:</strong> {user.first_name} {user.last_name}
                  </p>
                  <p>
                    <strong>Email:</strong> {user.email}
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>Username:</strong> {user.username}
                  </p>
                  <p>
                    <strong>Role:</strong> {getRoleBadge(user.role)}
                  </p>
                </div>
              </div>
            </Card.Body>
          </Card>

          {/* Application Settings */}
          <Card className="mb-4">
            <Card.Header className="bg-secondary text-white">
              <h5 className="mb-0">
                <i className="fas fa-cogs me-2"></i>
                Application Settings
              </h5>
            </Card.Header>
            <Card.Body>
              <p className="text-muted">
                Application settings and preferences will be available in future updates.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Settings;
